// resources/js/modules/initPinnedHorizontalTrack.js
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Pinea una section y traduce el scroll vertical consumido en desplazamiento
 * horizontal del track, hasta agotar su ancho — recién ahí libera el scroll.
 *
 * @param {Object} options
 * @param {string} options.section   - selector de la section a pinear (ej: '#welcome.welcome')
 * @param {string} options.wrapper   - selector del contenedor overflow-hidden
 * @param {string} options.track     - selector del track a trasladar
 * @param {number} [options.scrub=1] - suavizado del scrub (true = 1:1 sin lag, número = segundos de "catch-up")
 * @param {'ltr'|'rtl'} [options.direction='ltr']
 * @param {() => number} [options.offsetTop] - función que retorna el offset superior (ej: altura del navbar fijo) a restar del punto de pin. Se re-evalúa en cada refresh.
 * @returns {{ destroy: () => void, scrollTrigger: ScrollTrigger|null }}
 */
export function initPinnedHorizontalTrack({section, wrapper,
                                              track, scrub = 1,
                                              direction = 'ltr', offsetTop = () => 0
                                          } = {}) {
    const sectionEl = document.querySelector(section);
    const wrapperEl = document.querySelector(wrapper);
    const trackEl = document.querySelector(track);

    if (!sectionEl || !wrapperEl || !trackEl) {
        return { destroy: () => {}, scrollTrigger: null };
    }

    const sign = direction === 'rtl' ? 1 : -1;
    const getScrollDistance = () => Math.max(0, trackEl.scrollWidth - wrapperEl.clientWidth);

    const tween = gsap.to(trackEl, {
        x: () => sign * getScrollDistance(),
        ease: 'none',
        scrollTrigger: {
            trigger: sectionEl,
            start: () => `top ${offsetTop()}px`,
            end: () => `+=${getScrollDistance()}`,
            scrub,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
        },
    });

    return {
        scrollTrigger: tween.scrollTrigger,
        destroy() {
            tween.scrollTrigger?.kill();
            tween.kill();
            gsap.set(trackEl, { clearProps: 'transform' });
        },
    };
}
